import { initialSysEventsState, actions } from "./action";

export const SysEventsReducer = (state = initialSysEventsState, action) => {
    switch (action.type) {
        case actions.SYSEVENTS_GET_ALL_SUCCESS:
            return {
                ...state,
                sysEventsList: action.payload ? action.payload : {}
            };
        case actions.SYSEVENTS_UPDATE_SUCCESS:
            return {
                ...state,
                eventCmd: action.payload?.id ? {...action.payload, action: 'update'} : {}
            };
        case actions.SYSEVENTS_CREATE_SUCCESS:
            return {
                ...state,
                eventCmd: action.payload?.id ? {...action.payload, action: 'create'} : {}
            };
        case actions.SYSEVENTS_DELETE_SUCCESS:
            return {
                ...state,
                sysEeventCmdvents: action.payload?.id ? {...action.payload, action: 'delete'} : {}
            };
        case actions.SYSEVENTS_RESET_SUCCESS:
            return {
                ...state,
                eventCmd: {},
                filters: {}
            };
        case actions.SYSEVENTS_SET_FILTERS_REQUEST:
            return {
                ...state,
                filters: action.payload
            };
        default:
            return state;
    }
};
